import { Subject } from 'rxjs';

interface Loading {
    isShow: boolean;
}

const loadingSubject = new Subject<Loading>();

export const loadingService = {
    onLoading,
    loading
};

function onLoading() {
    return loadingSubject.asObservable();
}

function loading(isShow: boolean) {
    loadingSubject.next({ isShow });
}